import './reset.css'
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { AppProviders } from '@/component/provider/AppProviders'
import { AppRoutes } from '@/routes/AppRoutes'
import { useGlobalAudio } from '@/hooks/useGlobalAudio'

function App() {
    const { t } = useTranslation()
    const { audioRef, audioSrc } = useGlobalAudio()

    useEffect(() => {
        document.title = t('app.title.carearly')
    }, [t])

    return (
        <>
            <audio ref={audioRef} src={audioSrc} loop={true} />
            <AppProviders>
                <AppRoutes />
            </AppProviders>
        </>
    )
}

export default App

